
export default [

  {
    path: '/establecimientos',
    name: 'establecimientos',
    component: () => import('@/views/administracion/pages/establecimientos/ConsultarEstablecimientos.vue'),
    meta: {
      hideBreadcrumb: false,
      pageTitle: 'Establecimientos',
      breadcrumb: [
        {
          text: 'Consultar',
          active: true,
        },
      ],
      requiresAuth: true,
      requiredPermission: 'adm_consultar_establecimiento', // si existe
    },
  },

  {
    path: '/consultar_doctor',
    name: 'consultar_doctor',
    component: () => import('@/views/administracion/pages/doctores/ConsultarDoctor.vue'),
    meta: {
      hideBreadcrumb: true,
      pageTitle: 'Archivos',
      breadcrumb: [
        {
          text: 'doctor',
        },
        {
          text: 'Consultar Doctor',
          active: true,
        },
      ],
      requiresAuth: true,
      requiredPermission: 'adm_consultar_doctor', // Permiso requerido
      accion1: { url: '/crear_doctor' },
      excel: true,
      pdf: true,
    },
  },


  
  {
    path: '/crear_doctor',
    name: 'crear_doctor',
    component: () => import('@/views/administracion/pages/doctores/CrearDoctor.vue'),
    pageTitle: 'Doctor',
    meta: {
      pageTitle: 'Doctor',
      breadcrumb: [
        {
          text: 'doctor',
          to: '/consultar_doctor'
        },
        {
          text: 'Crear doctor',
          active: true,
        },
      ],
      requiresAuth: true,
      requiredPermission: 'adm_crear_doctor',
      excel: false,
      pdf: false,
    },
  },

  {
    path: '/editar_doctor/:token',
    name: 'editar_doctor',
    component: () => import('@/views/administracion/pages/doctores/EditarDoctor.vue'),
    
    meta: {
      pageTitle: 'Editar Doctor',
      breadcrumb: [
        {
          text: 'doctor',
          to: '/consultar_doctor' 
        },
        {
          text: 'Editar doctor',
          active: true,
        },
      ],
      requiresAuth: true,
      requiredPermission: 'adm_editar_doctor',
      excel: false,
      pdf: false,
    },
  },




  // Auxiliares
  {
    path: '/consultar_auxiliar',
    name: 'consultar_auxiliar',
    component: () => import('@/views/administracion/pages/auxiliares/ConsultarAuxiliar.vue'),
    meta: {
      pageTitle: 'Cartera Auxiliares',
      breadcrumb: [
        
        {
          text: 'Auxiliares Médicos',
          active: true,
        },
      ],
      requiresAuth: true,
      requiredPermission: 'adm_consultar_auxiliar',
      accion1: { url: '/crear_auxiliar' }
    },
  },

  {
    path: '/crear_auxiliar',
    name: 'crear_auxiliar',
    component: () => import('@/views/administracion/pages/auxiliares/CrearAuxiliar.vue'),
    pageTitle: 'Auxiliar Medico',
    meta: {
      pageTitle: 'Auxiliar Medico',
      breadcrumb: [
        {
          text: 'Consultar Auxiliar',
          to: '/consultar_auxiliar'
        },
        {
          text: 'Crear Auxiliar Medico',
          active: true,
        },
      ],
      requiresAuth: true,
      requiredPermission: 'crear_auxiliar',
    },
  },

  {
    path: '/editar_auxiliar/:token',
    name: 'editar_auxiliar',
    component: () => import('@/views/administracion/pages/auxiliares/EditarAuxiliar.vue'),
    meta: {
      pageTitle: 'Editar Auxiliar',
      breadcrumb: [
        {
          text: 'Consultar Auxiliar',
          to: '/consultar_auxiliar',
        },
        {
          text: 'Editar Auxiliar',
          active: true,
        },
      ],
      requiresAuth: true,
      requiredPermission: 'editar_auxiliar',
    },
  },
]